import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=8bed349a&"
import script from "./UserCreate.vue?vue&type=script&lang=js&"
export * from "./UserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bed349a')) {
      api.createRecord('8bed349a', component.options)
    } else {
      api.reload('8bed349a', component.options)
    }
    module.hot.accept("./UserCreate.vue?vue&type=template&id=8bed349a&", function () {
      api.rerender('8bed349a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/organization/users/UserCreate.vue"
export default component.exports